import { IconLoader2 } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useLocalStorageState from 'use-local-storage-state'
import img1 from "../../../Utils/assets/img/faces/5.jpg"
import img2 from "../../../Utils/assets/img/faces/6.jpg"
import img3 from "../../../Utils/assets/img/faces/7.jpg"
import { toast } from 'sonner'
import { GetRequest } from '../../../Utils/hooks/ApiHandler'
import { downloadCSV } from '../../../Utils/helpers/commonhelper'
import nodata from "../../../Utils/assets/img/leads_no_data_found_removebg.png";
import { Table } from 'react-bootstrap'

export const DealStatistics = () => {
    const [customer, setCustomer] = useLocalStorageState("customer")
    const token = customer?.token?.authorization
    const rf = customer?.token?.authentication
    const navigate = useNavigate()

    const headers = {
        Authentication: rf,
        Authorization: token,
    }

    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }

    // tabledata for deal
    const [dealsTableData, setDealTableData] = useState([])
    const [isCsvDownloading, setCsvDownloading] = useState(false)
    const [downloadId, setDownloadId] = useState(null)


    const imgArr = [img1, img2, img3]
    // getting random images function
    const getRandomImage = () => {
        const imgIndex = Math.floor(Math.random() * imgArr.length)
        return imgArr[imgIndex]
    }

    // deals statistics
    useEffect(() => {
        ; (async () => {
            try {
                const res = await GetRequest(
                    `dashboard/dealsStatistics/${customer.customer_details?.customer_id}/${customer.customer_details?.id}`,
                    { headers },
                    extras
                )
                if (res.status === false) {
                    return
                }
                const tableData =
                    res.data &&
                    res.data?.map((c) => ({
                        dealId: c.id,
                        pipeline_name: c.pipeline_name,
                        deal_count: c.deals_count,
                        budget: c.totalBudget,
                        users: c.users?.length,
                        probability: c.probability,
                    }))
                setDealTableData(tableData)
            } catch (error) {
                console.error("error fetching data")
            }
        })()
    }, [])
    // utility function to convert and download csv file
    const CsvConvert = async (dealId) => {
        try {
            setCsvDownloading(true)
            const res = await GetRequest(
                `dashboard/downloadDealsCsvData/${customer.customer_details?.customer_id}/${customer.customer_details?.id}/${dealId}`,
                { headers },
                extras
            )

            if (res.status === false) {
                return
            }

            if (res.data) {
                const status = downloadCSV(res.data)
                if (!status) {
                    setCsvDownloading(false)
                    toast.error("Error Generating CSV File!")
                    setDownloadId(null)
                    return
                }
                setCsvDownloading(false)
                setDownloadId(null)
            }
        } catch (error) {
            toast.error("Error Generating CSV File!")
            return
        }
    }

    return (
        <div className="col-xl-12">
            <div className="card px-2 pb-0 pt-3">
                <div className="addEnquiryHead " style={{ fontWeight: 600, paddingLeft: "2rem" }}>Deals Statistics</div>
                <hr className='mb-0' />
                <div style={{ padding: "1.5rem", minHeight: "30rem" }}>
                    <div className="listStyleForContact container-table">
                        <Table
                            className='border-0'
                            style={{
                                width: "100%",
                                tableLayout: "auto",
                            }}
                        >
                            <thead>
                                <tr style={{ backgroundColor: "#eaf7ff" }}>
                                    <th
                                        scope="col"
                                        className="text-center fs-12"
                                    >
                                        Sr No.
                                    </th>
                                    <th
                                        scope="col"
                                        className="text-center fs-12"
                                    >
                                        Pipeline Name
                                    </th>
                                    <th
                                        scope="col"
                                        className="text-center fs-12"
                                    >
                                        Deals Count
                                    </th>
                                    <th
                                        scope="col"
                                        className="text-center fs-12"
                                    >
                                        Users
                                    </th>
                                    <th
                                        scope="col"
                                        className="text-center fs-12"
                                    >
                                        Total Budget
                                    </th>
                                    <th
                                        scope="col"
                                        className="text-center fs-12"
                                    >
                                        Probability
                                    </th>
                                    <th
                                        scope="col"
                                        className="text-center fs-12"
                                    >
                                        Action
                                    </th>
                                </tr>
                            </thead>

                            <tbody className='position-relative'  >
                                {dealsTableData?.length > 0 ? (
                                    <React.Fragment>
                                        {dealsTableData?.map((row, idx) => (
                                            <tr key={idx}>
                                                <td className=" text-center align-middle fw-semibold fs-12">
                                                    {idx + 1}
                                                </td>
                                                <td className="text-center">
                                                    <div className="d-flex align-items-center fw-semibold ">
                                                        <span className="avatar avatar-sm me-2 avatar-rounded">
                                                            <img
                                                                src={getRandomImage()}
                                                                style={{
                                                                    width: "95%",
                                                                    borderRadius: "50%",
                                                                }}
                                                                alt="img"
                                                            />
                                                        </span>
                                                        {row.pipeline_name}
                                                    </div>
                                                </td>
                                                <td className="text-center align-middle">
                                                    <span
                                                        className={`badge ${idx === 0
                                                            ? "bg-info-transparent"
                                                            : idx === 1
                                                                ? "bg-primary-transparent"
                                                                : idx === 2
                                                                    ? "bg-danger-transparent"
                                                                    : idx === 3
                                                                        ? "bg-warning-transparent"
                                                                        : "bg-success-transparent"
                                                            }`}
                                                    >
                                                        {row.deal_count}
                                                    </span>
                                                </td>
                                                <td className="text-center align-middle">
                                                    <span
                                                        className={`crm-badge ${idx === 0
                                                            ? "bg-info-transparent"
                                                            : idx === 1
                                                                ? "bg-primary-transparent"
                                                                : idx === 2
                                                                    ? "crm-bg-danger-transparent"
                                                                    : idx === 3
                                                                        ? "bg-warning-transparent"
                                                                        : "bg-success-transparent"
                                                            }`}
                                                    >
                                                        {row.users}
                                                    </span>
                                                </td>
                                                <td className="text-center align-middle">
                                                    <span
                                                        className={`badge ${idx === 0
                                                            ? "bg-info-transparent"
                                                            : idx === 1
                                                                ? "bg-primary-transparent"
                                                                : idx === 2
                                                                    ? "bg-danger-transparent"
                                                                    : idx === 3
                                                                        ? "bg-warning-transparent"
                                                                        : "bg-success-transparent"
                                                            }`}
                                                    >
                                                        ₹{row.budget?.toLocaleString()}
                                                    </span>
                                                </td>
                                                <td className="text-center align-middle">
                                                    {row.probability}
                                                </td>
                                                <td className="text-center align-middle">
                                                    <div className="d-flex gap-2">
                                                        {downloadId === row.dealId &&
                                                            isCsvDownloading ? (
                                                            <IconLoader2
                                                                size={18}
                                                                stroke={2}
                                                                className="rotating"
                                                            />
                                                        ) : (
                                                            <a
                                                                href="javascript:void(0);"
                                                                className={`btn btn-icon btn-sm btn-success-light ${isCsvDownloading ? "disabled" : ""
                                                                    }`}
                                                                onClick={() => {
                                                                    if (!isCsvDownloading) {
                                                                        CsvConvert(row.dealId)
                                                                        setDownloadId(row.dealId)
                                                                    }
                                                                }}
                                                                style={{
                                                                    pointerEvents: isCsvDownloading
                                                                        ? "none"
                                                                        : "auto",
                                                                    opacity: isCsvDownloading ? 0.5 : 1,
                                                                    cursor: isCsvDownloading
                                                                        ? "not-allowed"
                                                                        : "pointer",
                                                                }}
                                                            >
                                                                <i className="fa-solid fa-download"></i>
                                                            </a>
                                                        )}

                                                        <a
                                                            href="javascript:void(0);"
                                                            className="btn btn-icon btn-sm btn-primary-light"
                                                        >
                                                            <i
                                                                className="fa-solid fa-pencil"
                                                                onClick={() =>
                                                                    navigate("/deals", {
                                                                        state: { id: row.dealId },
                                                                    })
                                                                }
                                                            ></i>
                                                        </a>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </React.Fragment>)
                                    :
                                    <td
                                        colSpan={7}
                                        className="text-center "
                                        style={{ height: "300px" }}
                                    >
                                        <img
                                            src={nodata}
                                            alt=""
                                            style={{ width: "17rem" }}
                                        />
                                    </td>
                                }
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        </div >
    )
}
